import { render } from "./AntiFraudAlerts.vue?vue&type=template&id=8d815576&scoped=true&ts=true"
import script from "./AntiFraudAlerts.vue?vue&type=script&lang=ts"
export * from "./AntiFraudAlerts.vue?vue&type=script&lang=ts"

import "./AntiFraudAlerts.vue?vue&type=style&index=0&id=8d815576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d815576"]])

export default __exports__